module.exports = __webpack_public_path__ + "static/img/rz(2).e05098e6.jpeg";